import React from 'react'
import Banner from './banner/Banner';
import ResumeDownload from './resumeDownload/ResumeDownload';
import Contact from './resumeDownload/Contact';
import Navbar from '../components/Navbar/Navbar';
import DisPlayProject from './project/DisPlayProject';
import about from './about/About';
import About from './about/About';


const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <About></About>
            <DisPlayProject></DisPlayProject>
            <Contact></Contact>
        </div>
    )
}

export default Home
